export default {
  acceptdButton: 'Aceptar',
  rejectButton: 'Rechazar',
  termsAndConditionsLabel: 'He leído y acepto los términos y condiciones'
}
